import { VehicleImageWithMeta } from '../../types/vehicle';
import { createImageUrl } from './create-image-url';

export function findImageBySequence(
  images: VehicleImageWithMeta[],
  /** 0-based index */
  sequence: number,
  cdnUrl: string
) {
  // Get the nth image  (0 base)
  const image = images[sequence];

  return image ? createImageUrl(cdnUrl, image) : undefined;
}
